import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import Button from '../../components/button/index';
import { DARK } from '../../components/button/variants';
import messages from './messages';

const ClassConfirmation = ({ icon, children, handleOnCloseModal, intl }) => (
    <div className={css.classConfirmationContainer}>
        <div className={css.icon}>
            <SvgIcon icon={icon} />
        </div>
        <div className={css.title}>{children}</div>
        <Button
            containerClassName={`cta-button ${css.buttonWrapper}`}
            handleOnClick={handleOnCloseModal}
            label={intl.formatMessage(messages.ok)}
            variant={DARK} />
    </div>
);

ClassConfirmation.propTypes = {
    icon: PropTypes.string,
    handleOnCloseModal: PropTypes.func,
    intl: intlShape.isRequired,
    children: PropTypes.node
};

export default injectIntl(ClassConfirmation);



// WEBPACK FOOTER //
// ./app/components/class-confirmation/index.js